import { gql } from "@apollo/client";

export const SAVE_EXEMPTION = gql`
  mutation saveExemption($input: SaveExemptionInput!) {
    invoice {
      saveExemption(input: $input) {
        success
      }
    }
  }
`;
